import { render, staticRenderFns } from "./Level3-2.vue?vue&type=template&id=0366ba56&scoped=true&"
import script from "./Level3-2.vue?vue&type=script&lang=js&"
export * from "./Level3-2.vue?vue&type=script&lang=js&"
import style0 from "./Level3-2.vue?vue&type=style&index=0&id=0366ba56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366ba56",
  null
  
)

export default component.exports